import React, { useState, useEffect } from 'react';
import { Form, Button } from 'tabler-react';

const SearchInput = ({ value = '', onSubmit, placeholder = 'Search for...' }) => {
  const [draft, setDraft] = useState(value);

  useEffect(() => { setDraft(value); }, [value]);

  const commit = (term) => {
    if (term === value) return;
    onSubmit(term);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    commit(draft.trim());
  };

  const handleClear = () => {
    setDraft('');
    commit('');
  };

  return (
    <form onSubmit={handleSubmit} role="search" className="d-flex">
      <Form.Input
        icon="search"
        position="append"
        placeholder={placeholder}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
      />
      {draft && (
        <Button
          type="button"
          color="secondary"
          icon="x"
          size="sm"
          className="ml-1"
          onClick={handleClear}
        />
      )}
    </form>
  );
};

export default SearchInput;
